import React from 'react';
import { PlayerAvatar } from './PlayerAvatar';

const actionButtons = [
  { type: 'goal', label: 'G', name: 'Goal', color: 'from-green-500 to-green-700', border: 'border-green-400/50', glow: 'rgba(34,197,94,0.6)' },
  { type: 'yellow_card', label: 'Y', name: 'Yellow Card', color: 'from-yellow-500 to-yellow-700', border: 'border-yellow-400/50', glow: 'rgba(234,179,8,0.6)' },
  { type: 'red_card', label: 'R', name: 'Red Card', color: 'from-red-500 to-red-700', border: 'border-red-400/50', glow: 'rgba(239,68,68,0.6)' },
  { type: 'substitution', label: 'S', name: 'Substitution', color: 'from-blue-500 to-blue-700', border: 'border-blue-400/50', glow: 'rgba(59,130,246,0.6)' },
];

export const PlayerActionModal = ({ playerPos, onAction, onClose }) => {
  if (!playerPos) return null;

  const { player, jersey_number, is_captain } = playerPos;
  const fullName = `${player?.first_name || ''} ${player?.last_name || ''}`.trim() || 'Unknown';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-gray-800 rounded-2xl border border-gray-600 shadow-2xl w-80 overflow-hidden animate-[fadeIn_0.15s_ease-out]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Player Info Header */}
        <div className="flex items-center gap-4 p-5 border-b border-gray-700">
          <PlayerAvatar player={player} jerseyNumber={jersey_number} size={64} />
          <div className="flex-1 min-w-0">
            <div className="text-lg font-bold text-white truncate">{fullName}</div>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-gray-400 font-mono text-sm">#{jersey_number}</span>
              {is_captain && (
                <span className="px-2 py-0.5 bg-amber-600 text-white text-xs font-bold rounded">C</span>
              )}
            </div>
          </div>
        </div>

        {/* 2x2 Action Grid */}
        <div className="grid grid-cols-2 gap-3 p-5">
          {actionButtons.map((btn) => (
            <button
              key={btn.type}
              onClick={() => {
                onAction(btn.type, playerPos);
                onClose();
              }}
              className={`
                flex flex-col items-center justify-center
                h-20 rounded-xl
                bg-gradient-to-b ${btn.color}
                border-2 ${btn.border}
                transition-all active:scale-95 active:brightness-110
              `}
              style={{ boxShadow: `0 0 25px ${btn.glow}` }}
            >
              <span className="text-white font-bold text-2xl drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
                {btn.label}
              </span>
              <span className="text-white/80 text-xs mt-1">{btn.name}</span>
            </button>
          ))}
        </div>

        {/* Cancel Button */}
        <div className="px-5 pb-5">
          <button
            onClick={onClose}
            className="w-full py-3 rounded-xl bg-gray-700 text-gray-300 font-semibold text-sm border border-gray-600 hover:bg-gray-600 transition-colors active:scale-[0.98]"
          >
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
};
